export default "__VITE_ASSET__7d197356__"